import { useState, useRef, useEffect } from "react";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import audio from "./../../assets/beep.mp3"


function BarcodeReader({ onScan }) {
    const [data, setData] = useState("");
    const [lastScan, setLastScan] = useState("");
    const lastScanTimeRef = useRef(0);
    const beep = new Audio(audio);

    // Debounce mechanism to prevent duplicate scans
    const handleScan = (scanData) => {
        const now = Date.now();
        const timeSinceLastScan = now - lastScanTimeRef.current;

        // Only process if it's been at least 1 second since last scan
        // or if it's a different barcode
        if (timeSinceLastScan > 1000 || scanData !== lastScan) {
            setData(scanData);
            setLastScan(scanData);
            lastScanTimeRef.current = now;
            onScan(scanData);
            beep.play().catch(e => console.log(e));
        }
    };

    return (
        <div>
            <BarcodeScannerComponent
                width={500}
                height={400}
                facingMode="environment"
                // Better video constraints for barcode reading
                constraints={{
                    video: {
                        facingMode: "environment",
                        width: { ideal: 1920 },
                        height: { ideal: 1080 },
                    }
                }}
                onUpdate={(err, result) => {
                    if (result && result.text) {
                        handleScan(result.text);
                    }
                    if (err) {
                        console.error("Barcode scanner error:", err);
                    }
                }}
                // Increase scan frequency for better detection
                delay={100}
            />
            <div style={{
                marginTop: "0.5rem",
                textAlign: "center",
                fontSize: "0.9rem",
                color: "#666"
            }}>
                {data ? `Pročitano: ${data}` : "Usmjerite kameru na barkod"}
            </div>
        </div>
    );
}


export default BarcodeReader;